/** @jsx jsx */
import PropTypes from "prop-types"
import { Fragment } from "react"
import { jsx } from "theme-ui"
import Variant from "@components/Variant"

import Border from "@components/Border"

import Testimonials from "./Testimonials"

export default function TestimonialsWithBorder(props) {
  return (
    <Fragment>
      <Variant
        as="section"
        sx={{
          backgroundColor: `rgba(${props.backgroundcolor})`,
          borderRadius: "30px",
        }}
        variants={["sectionContainer"]}
      >
        <Testimonials as="article" {...props} />
      </Variant>
      <Border />
    </Fragment>
  )
}

TestimonialsWithBorder.typeName = "ContentfulTestimonialBlock"

TestimonialsWithBorder.propTypes = {
  backgroundcolor: PropTypes.string.isRequired,
}
